import axios from '@axios'

export default {
  namespaced: true,
  state:()=> ({
    root:null,
    list:[],
    rowsFrom:0,
    rowsTo:0,
    rowsTotal:0,
    perPage:10,
    currentPage:1,
    loading:true,
    uniqueIdFilter:'',
    simIdFilter:'',
    customersOptions:[],
    contractsOptions:[],
    techniciansOptions:[],
    productsOptions:[],
    customersFilter:[],
    contractsFilter:[],
    techniciansFilter:[],
    productsFilter:[]
  }),
  mutations:{
    updateRoot(state, payload){
      state.root = payload
    },
    updateList(state, payload){
      state.list = payload
    },
    updateRowsFrom(state, payload){
      state.rowsFrom = payload
    },
    updateRowsTo(state, payload){
      state.rowsTo = payload
    },
    updateRowsTotal(state, payload){
      state.rowsTotal = payload
    },
    updatePerPage(state, payload){
      state.perPage = payload.value
    },
    updateCurrentPage(state, payload){
      state.currentPage = payload.value
    },
    startLoadingState(state){
      state.loading = true
    },
    stopLoadingState(state){
      state.loading = false
    },
    updateCustomersOptions(state, payload){
      state.customersOptions = payload
    },
    updateContractsOptions(state, payload){
      state.contractsOptions = payload
    },
    updateTechniciansOptions(state, payload){
      state.techniciansOptions = payload
    },
    updateProductsOptions(state, payload){
      state.productsOptions = payload
    },
    updateUniqueIdFilter(state, payload){
      state.uniqueIdFilter = payload.value
    },
    updateCustomersFilter(state, payload){
      state.customersFilter = payload.value
    },
    updateContractsFilter(state, payload){
      state.contractsFilter = payload.value
    },
    updateTechniciansFilter(state, payload){
      state.techniciansFilter = payload.value
    },
    updateProductsFilter(state, payload){
      state.productsFilter = payload.value
    }

  },
  actions: {
    fetchList({ commit, getters }){
      commit('startLoadingState')
      axios.get('fieldServices', { params:{
        length: getters.perPage,
        page: getters.currentPage,
        service_type:'installation',
        ...(getters.isUsingUniqueIdFilter && {unique_id: getters.uniqueIdFilter}),
        ...(getters.isUsingSimIdFilter && {sim_id: getters.simIdFilter}),
        ...(getters.isUsingCustomersFilter && {customers: getters.customersFilter}),
        ...(getters.isUsingContractsFilter && {contracts: getters.contractsFilter}),
        ...(getters.isUsingTechniciansFilter && {technicians: getters.techniciansFilter}),
        ...(getters.isUsingProductsFilter && {products: getters.productsFilter}),
      }})
      .then(r => {
          commit('updateList', r.data.data)
          commit('updateRowsFrom', r.data.meta.from)
          commit('updateRowsTo', r.data.meta.to)
          commit('updateRowsTotal', r.data.meta.total)
          commit('stopLoadingState')
      })
      .catch(error => {})

    },
    fetchFiltersOptions({ commit }){
      axios.get('filters/getFilterBy', { params:{
        type: 'fieldService',
        service_type:'installation'
      }})
      .then(r => {
          commit('updateCustomersOptions', r.data.data.customers)
          commit('updateContractsOptions', r.data.data.contracts)
          commit('updateTechniciansOptions', r.data.data.technicians)
          commit('updateProductsOptions', r.data.data.products)
      })
      .catch(error => {})
    },
    delete({ commit, getters, dispatch }, payload){
      getters.root.$swal({
        icon:'warning',
        title: getters.root.$i18n.t("SWAL_CONFIRM_BOX_TITLE"),
        text: getters.root.$i18n.t('FIELD_SERVICES_INSTALLATION_DELETE_CONFIRMATION'),
        showCancelButton: true,
        confirmButtonText: getters.root.$i18n.t('SWAL_YES_BUTTON_LABEL'),
        cancelButtonText: getters.root.$i18n.t('SWAL_CANCEL_BUTTON_LABEL'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( confirmBox => {
        if ( confirmBox.isConfirmed) {
          commit('startLoadingState')
          axios.delete(`fieldServices/${payload.id}` , {params:{
            service_type:'installation', 
            product_type:payload.product_type
          }})
          .then( response => {
              commit('stopLoadingState')
              getters.root.$bvToast.toast(
                getters.root.$i18n.t('FIELD_SERVICES_INSTALLATION_DELETE_SUCCESS_MESSAGE'), {
                variant: 'success',
                solid: true,
              })
              dispatch('fetchList')
              dispatch('fetchFiltersOptions')
            }).catch( reason => {
              getters.root.$bvToast.toast(
                getters.root.$i18n.t('FIELD_SERVICES_INSTALLATION_DELETE_FAILURE_MESSAGE'), {
                variant: 'danger',
                solid: true,
              })
            })
        }
      })
    }
  },
  getters:{
    root(state){
      return state.root
    },
    isLoading(state){
      return state.loading
    },
    perPageOptions(){
      return [2,10,50,100,500]
    },
    perPage(state){
      return state.perPage
    },
    currentPage(state){
      return state.currentPage
    },
    uniqueIdFilter(state){
      return state.uniqueIdFilter
    },
    isUsingUniqueIdFilter(state){
      return state.uniqueIdFilter.length > 0
    },
    simIdFilter(state){
      return state.simIdFilter
    },
    isUsingSimIdFilter(state){
      return state.simIdFilter.length > 0
    },
    customersOptions(state){
      return state.customersOptions
    },
    customersFilter(state){
      return state.customersFilter
    },
    isUsingCustomersFilter(state){
      return state.customersFilter.length > 0
    },
    contractsOptions(state){
      return state.contractsOptions
    },
    contractsFilter(state){
      return state.contractsFilter
    },
    isUsingContractsFilter(state){
      return state.contractsFilter.length > 0
    },
    techniciansOptions(state){
      return state.techniciansOptions
    },
    techniciansFilter(state){
      return state.techniciansFilter
    },
    isUsingTechniciansFilter(state){
      return state.techniciansFilter.length > 0
    },
    productsOptions(state){
      return state.productsOptions
    },
    productsFilter(state){
      return state.productsFilter
    },
    isUsingProductsFilter(state){
      return state.productsFilter.length > 0
    },
    list(state){
      return state.list
    },
    tableMeta(state, getters){
      return `${ getters.root.$i18n.t('Showing') } ${ state.rowsFrom } to ${ state.rowsTo } of ${ state.rowsTotal } ${ getters.root.$i18n.t('entries') }`
    },
    tableTotalRows(state){
      return state.rowsTotal
    },
    tableColumns(state, getters){
      return [
        { 
          key: 'id', 
          sortable: true,
          label:getters.root.$i18n.t('id')
        },
        { 
          key: 'datetime', 
          sortable: true, 
          label:getters.root.$i18n.t('FIELD_SERVICES_DATETIME_LABEL')
        }, 
        { 
          key: 'technician', 
          sortable: true, 
          label:getters.root.$i18n.t('FIELD_SERVICES_TECHNICIAN_LABEL')
        },
        { 
          key: 'customer', 
          sortable: true, 
          label:getters.root.$i18n.t('FIELD_SERVICES_CUSTOMER_LABEL')
        },
        { 
          key: 'product_type', 
          sortable: true, 
          label:getters.root.$i18n.t('FIELD_SERVICES_PRODUCT_TYPE_LABEL')
        },
        { 
          key: 'data.unique_id', 
          sortable: true, 
          label:getters.root.$i18n.t('FIELD_SERVICES_UNIQUE_ID_LABEL')
        },
        { 
          key: 'data.sim_id', 
          sortable: true, 
          label:getters.root.$i18n.t('FIELD_SERVICES_SIM_ID_LABEL')
        },
        { 
          key: 'actions', 
          label: getters.root.$i18n.t('actions') 
        }
      ]
    }
  }
}
